/*
 * ZEYMODE ETQ — Theme JavaScript
 */

(function() {
  'use strict';

  /* ---- Sticky Header ---- */
  var header = document.querySelector('[data-header]');
  if (header) {
    var lastScroll = 0;
    window.addEventListener('scroll', function() {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop > 80) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled');
      }
      lastScroll = scrollTop;
    }, { passive: true });
  }

  /* ---- Cart Drawer ---- */
  var cartOpen = document.querySelectorAll('[data-cart-open]');
  var cartClose = document.querySelector('[data-cart-close]');
  var cartDrawer = document.querySelector('.cart-drawer');
  var cartOverlay = document.querySelector('.cart-drawer__overlay');

  function openCart() {
    if (cartDrawer) cartDrawer.classList.add('is-open');
    if (cartOverlay) cartOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeCart() {
    if (cartDrawer) cartDrawer.classList.remove('is-open');
    if (cartOverlay) cartOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  cartOpen.forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      openCart();
    });
  });

  if (cartClose) cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  /* ---- Cart AJAX ---- */
  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function(el) {
      el.textContent = count;
    });
  }

  function updateCartDrawer() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        updateCartCount(cart.item_count);

        var itemsEl = document.querySelector('.cart-drawer__items');
        var emptyEl = document.querySelector('.cart-drawer__empty');
        var footerEl = document.querySelector('.cart-drawer__footer');
        var subtotalEl = document.querySelector('[data-cart-subtotal]');

        if (cart.item_count === 0) {
          if (itemsEl) itemsEl.innerHTML = '';
          if (emptyEl) emptyEl.style.display = '';
          if (footerEl) footerEl.style.display = 'none';
          return;
        }

        if (emptyEl) emptyEl.style.display = 'none';
        if (footerEl) footerEl.style.display = '';

        if (subtotalEl) {
          subtotalEl.textContent = formatMoney(cart.total_price);
        }

        // Free shipping bar
        var bar = document.querySelector('.free-shipping-bar');
        if (bar) {
          var threshold = parseInt(bar.dataset.threshold) || 15000;
          var pct = Math.min(100, (cart.total_price / threshold) * 100);
          var fill = bar.querySelector('.free-shipping-bar__fill');
          var text = bar.querySelector('.free-shipping-bar__text');
          if (fill) fill.style.width = pct + '%';
          if (text) {
            if (cart.total_price >= threshold) {
              text.textContent = 'You qualify for free shipping!';
            } else {
              var remaining = formatMoney(threshold - cart.total_price);
              text.textContent = remaining + ' away from free shipping';
            }
          }
        }

        if (itemsEl) {
          var html = '';
          cart.items.forEach(function(item, index) {
            html += '<div class="cart-item">';
            html += '<div class="cart-item__image"><a href="' + item.url + '"><img src="' + getSizedImageUrl(item.image, '160x') + '" alt="' + escapeHtml(item.title) + '"></a></div>';
            html += '<div class="cart-item__details">';
            html += '<h4 class="cart-item__title">' + escapeHtml(item.product_title) + '</h4>';
            if (item.variant_title && item.variant_title !== 'Default Title') {
              html += '<p class="cart-item__variant">' + escapeHtml(item.variant_title) + '</p>';
            }
            html += '<p class="cart-item__price">' + formatMoney(item.final_line_price) + '</p>';
            html += '<div class="cart-item__actions">';
            html += '<div class="quantity-selector">';
            html += '<button type="button" onclick="changeCartQty(' + (index + 1) + ',' + (item.quantity - 1) + ')">−</button>';
            html += '<input type="number" value="' + item.quantity + '" min="0" onchange="changeCartQty(' + (index + 1) + ', this.value)">';
            html += '<button type="button" onclick="changeCartQty(' + (index + 1) + ',' + (item.quantity + 1) + ')">+</button>';
            html += '</div>';
            html += '<button class="cart-item__remove" onclick="changeCartQty(' + (index + 1) + ', 0)">Remove</button>';
            html += '</div></div></div>';
          });
          itemsEl.innerHTML = html;
        }
      });
  }

  window.changeCartQty = function(line, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: parseInt(qty) })
    })
    .then(function(r) { return r.json(); })
    .then(function() { updateCartDrawer(); });
  };

  // Intercept add-to-cart forms
  document.addEventListener('submit', function(e) {
    var form = e.target;
    if (form.action && form.action.indexOf('/cart/add') !== -1) {
      e.preventDefault();
      fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(form)
      })
      .then(function(r) { return r.json(); })
      .then(function() {
        updateCartDrawer();
        openCart();
      });
    }
  });

  // Initial cart count
  updateCartDrawer();

  /* ---- Helpers ---- */
  function formatMoney(cents) {
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function getSizedImageUrl(url, size) {
    if (!url) return '';
    return url.replace(/(\.[^.]+)$/, '_' + size + '$1');
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  /* ---- Quantity Buttons (product page) ---- */
  document.addEventListener('click', function(e) {
    if (e.target.matches('[data-qty-minus]')) {
      var input = e.target.parentElement.querySelector('[data-qty-input]');
      if (input && parseInt(input.value) > 1) input.value = parseInt(input.value) - 1;
    }
    if (e.target.matches('[data-qty-plus]')) {
      var input = e.target.parentElement.querySelector('[data-qty-input]');
      if (input) input.value = parseInt(input.value) + 1;
    }
  });

  /* ---- Size Selector ---- */
  document.addEventListener('click', function(e) {
    if (e.target.matches('.size-option') && !e.target.classList.contains('is-sold-out')) {
      var parent = e.target.closest('.size-selector');
      if (parent) {
        parent.querySelectorAll('.size-option').forEach(function(s) { s.classList.remove('is-selected'); });
        e.target.classList.add('is-selected');
      }
    }
  });

})();
